import { render } from "./AdminShipmentDashboard.vue?vue&type=template&id=05f1b14f&scoped=true"
import script from "./AdminShipmentDashboard.vue?vue&type=script&lang=js"
export * from "./AdminShipmentDashboard.vue?vue&type=script&lang=js"

import "./AdminShipmentDashboard.vue?vue&type=style&index=0&id=05f1b14f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f1b14f"]])

export default __exports__